var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('line',{attrs:{"x1":_vm.normalizeX(_vm.vector.start.x),"y1":_vm.normalizeY(_vm.vector.start.y),"x2":_vm.normalizeX(_vm.vector.end.x),"y2":_vm.normalizeY(_vm.vector.end.y)}})}
var staticRenderFns = []

export { render, staticRenderFns }